<div class="tosite-luku-container">
  <mat-tab-group [(selectedIndex)]="alivalilehtiIndex" mat-stretch-tabs="false">
    <mat-tab label="Prompti">
      <ng-template matTabContent>
        <app-tosite-luku-prompti></app-tosite-luku-prompti>
      </ng-template>
    </mat-tab>
    <mat-tab label="Testisetit">
      <ng-template matTabContent>
        <app-tosite-luku-setit></app-tosite-luku-setit>
      </ng-template>
    </mat-tab>
    <mat-tab label="Testiajot">
      <ng-template matTabContent>
        <app-tosite-luku-ajot></app-tosite-luku-ajot>
      </ng-template>
    </mat-tab>
    <mat-tab label="Tuotanto">
      <ng-template matTabContent>
        <app-tosite-luku-tuotanto></app-tosite-luku-tuotanto>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
